    import React, { useState, useEffect } from 'react';
    import { oneKlicks } from '../SDK/oneclick';

    const Feedbackcount = ({ data, type = 'doctor' }) => {
        console.log('Feedbackcount data :', data);

        const [feedback, setFeedback] = useState([]);

        // Calculate average rating from feedback
        const calculateAverageRating = () => {
            if (!feedback || feedback.length === 0) return 0;
            const totalRating = feedback.reduce((sum, item) => sum + parseInt(item.rating), 0);
            return parseFloat((totalRating / feedback.length).toFixed(1));
        };

        const getAverageRating = calculateAverageRating();


        useEffect(() => {
            if (data && data.id) {
                fetchFeedback();
            }
        }, [data]);

        const fetchFeedback = async () => {
            if (!data || !data.id) {
                console.log('No data or ID provided');
                setFeedback([]);
                return;
            }
            
            const tableSchema = '';
            const tableName = 'feedbacks';
            const conditions = {
                doctor_id: data.id
            };
            const orderBy = 'id DESC';
            const search = '';
            const pagination = '';
            const margedata = '';
            
            try {
                const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
                console.log('Feedback response :', response);
                if (response && response.data) {
                    console.log('Feedback data :', response.data);
                    setFeedback(response.data);
                } else {
                    setFeedback([]);
                    console.log('No feedback found');
                }
            } catch (error) {
                console.error('Error fetching feedback:', error);
                setFeedback([]);
            }
        };
        return (
            type === 'doctor' ? (
                <li style={{ display: 'flex', alignItems: 'center', fontSize: 15, color: '#888' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {feedback.length < 1 ? (
                            // show 1 stars black color
                            <span
                                    style={{
                                        color: '#e0e0e0',
                                        fontSize: 18,
                                    }}
                                >
                                    ★
                                </span>
                        ) : (
                        [1, 2, 3, 4, 5].map((star) => (
                            <span
                                key={star}
                                style={{
                                    color: star <= getAverageRating ? '#ffd700' : '#e0e0e0',
                                    fontSize: 18,
                                    marginRight: 2
                                }}
                            >
                                ★
                            </span>
                        ))
                        )}
                    </div>
                    <em style={{ marginLeft: 4, color: '#666', fontWeight: 500 }}>
                        {feedback.length} Rating{feedback.length !== 1 ? 's' : ''}
                    </em>
                </li>
            ) : (
                <>
                    <span>
                        {feedback.length < 1 ? (
                            // show 1 stars black color
                            <span
                                style={{
                                    color: '#e0e0e0',
                                    fontSize: 18,
                                    marginRight: 2
                                }}
                            >
                                ★
                            </span>
                        ) : (
                            [1, 2, 3, 4, 5].map((star) => (
                                <span
                                    key={star}
                                    style={{
                                        color: star <= getAverageRating ? '#ffd700' : '#e0e0e0',
                                        fontSize: 18,
                                        marginRight: 2
                                    }}
                                >
                                    ★
                                </span>
                            ))
                        )}
                    </span>
                    <em style={{ marginLeft: 4, color: '#666', fontWeight: 500 }}>{feedback.length} Rating{feedback.length !== 1 ? 's' : ''}</em>
                </>
                
            )
        );
    };

    export default Feedbackcount;
